var SimpleModel = /** @class */ (function () {
    function SimpleModel(storage, events, _keyItem) {
        this.storage = storage;
        this.events = events;
        this._keyItem = _keyItem;
        this._event = {
            LOADED: this._keyItem + ':loaded',
            CLEARED: this._keyItem + ':cleared',
        };
    }
    Object.defineProperty(SimpleModel.prototype, "event", {
        get: function () {
            return this._event;
        },
        enumerable: true,
        configurable: true
    });
    SimpleModel.prototype.loadEncryptData = function () {
        var _this = this;
        this.storage.load(this._keyItem).then(function (res) {
            if (res != null && (typeof res != 'string')) {
                _this.__model = res;
                _this.events.publish(_this.event.LOADED);
            }
        });
    };
    SimpleModel.prototype.save = function (storageData) {
        storageData.key = this._keyItem;
        storageData.item = this.__model;
        return this.storage.saveAs(storageData);
    };
    return SimpleModel;
}());
export { SimpleModel };
//# sourceMappingURL=simpleModel.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/models/simpleModel.js
// module id = 163
// module chunks = 14